import { createTheme } from "@mui/material/styles";
import typography from "./typography";
import { customBreakpoints } from "./responsiveness";

// Reused color tokens to avoid duplicated string literals flagged by linters
const SCROLLBAR_TRACK_COLOR = "#FFFFFF";
const SCROLLBAR_THUMB_COLOR = "#111827";

const TOYOTA_TYPE_FONT_STACK = '"Toyota Type", "ToyotaType", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';

const theme = createTheme({
  // Ensure overlays (Popover) render above DataTable sticky layers.
  // MUI Tooltip defaults are higher than Modal/Popover; that's why Tooltip was fine.
  zIndex: {
    modal: 1700,
    tooltip: 1800,
  },
  breakpoints: customBreakpoints,
  typography: {
    fontFamily: TOYOTA_TYPE_FONT_STACK,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        typography,
        html: {
          scrollBehavior: "smooth",
          fontFamily: TOYOTA_TYPE_FONT_STACK,
        },
        body: {
          fontFamily: TOYOTA_TYPE_FONT_STACK,
          scrollbarColor: `${SCROLLBAR_THUMB_COLOR} ${SCROLLBAR_TRACK_COLOR}`,
          "&::-webkit-scrollbar": {
            width: 8,
            height: 8
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: SCROLLBAR_TRACK_COLOR
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: SCROLLBAR_THUMB_COLOR,
            borderRadius: 4
          }
        },
        '#root': {
          fontFamily: TOYOTA_TYPE_FONT_STACK,
        },
        'button, input, textarea, select': {
          fontFamily: 'inherit',
        },
        // Ensure popovers/poppers render above sticky DataTable layers.
        // Some table implementations use high z-index for sticky headers.
        ".MuiPopover-root, .MuiPopper-root": {
          zIndex: "1700 !important"
        },
        ".MuiPopover-paper, .MuiPopper-root .MuiPaper-root": {
          zIndex: "1700 !important"
        }
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          boxShadow: 'none',
          border: 'none',
          outline: 'none'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          outline: 'none'
        }
      }
    },
  },
});

export default theme;
